import React from 'react';

import { Text } from '~/components/core';
import { StatesConfigurationFormik } from '~/components/SystemConfiguration/AutomaticRulesConfiguration/Notifications/NotificationRuleDialog/StatesConfigurationFormik';
import { isNotificationStatesScopeEnabled } from '~/components/SystemConfiguration/AutomaticRulesConfiguration/Notifications/utils';
import NotificationConfigurationFieldsFormikInner from '~/components/SystemConfiguration/NotificationUtils/NotificationConfigurationFieldsFormikInner';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';

const RuleNotificationConfigurationFieldsFormik: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { organization } = useSysconfig();

  return (
    <div>
      {isNotificationStatesScopeEnabled(organization) ? (
        <>
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
            Select Loss Location by States
          </Text>
          <StatesConfigurationFormik />
        </>
      ) : null}
      <NotificationConfigurationFieldsFormikInner />
    </div>
  );
};

export default RuleNotificationConfigurationFieldsFormik;
